import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const NoContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0px 9px;
  min-height: 100px;
  display: flex;
  margin: 0 15px;

  p {
    margin-left: 10px;
  }
  @media (min-width: 1024px) {
    margin: 0;
  }
`;

export const NoContentText = styled.p`
  display: inline-block;
  font-family: var(--oc-font-family);
  font-size: 16px;
  line-height: 22px;
  color: #9d9da3;
  margin-left: 10px;
`;

export const infoIcon = css`
  display: inline-block;
  transform: translateY(3px);
`;
